<div class="customer-training-dialog">
  <div mat-dialog-title class="header d-flex align-items-center">
    <h2 class="ml-4 mr-3">Help Materials</h2>
    <div class="dropdown-container">
      <mat-form-field class="customer-training-pill-select active section-dropdown">
        <mat-label>Section</mat-label>
        <mat-select [formControl]="selectControl" (selectionChange)="onChangeGroupSelect($event)" panelClass="panel">
          @for (selectOption of selectOptions; track selectOption.value) {
            @if (selectOption.value && selectOption.options.length === 0) {
              <mat-option class="menu-option" [value]="selectOption.value">
                {{ selectOption.label }}
              </mat-option>
            }
            @if (selectOption.options.length > 0) {
              <mat-optgroup class="menu-option-group" [label]="selectOption.label">
                @for (option of selectOption.options; track option.value) {
                  <mat-option class="menu-option" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-content class="content">
    <mat-tab-group class="mt-3 hub-page-tabs" mat-stretch-tabs="false">
      <mat-tab label="Videos">
        @if (videos.length > 0) {
          <div class="my-3 videos-container">
            <!-- Selected Video -->
            <div>
              <video class="video" [src]="selectedVideo.path" type="video/mp4" controls></video>
              <h3 class="subheadline font-size-headline5 mb-0">{{ formatName(selectedVideo.name) }}</h3>
              <p>{{ formatDate(selectedVideo.date) }}</p>
            </div>
            <!-- Available videos -->
            <div>
              <div>
                <h3 class="subheadline font-size-headline5">More Videos</h3>
                @for (video of videos; track video.path) {
                  <div
                    class="d-flex customer-training__available-video"
                    tabindex="0"
                    (click)="changeSelectedVideo(video)"
                  >
                    <video width="230px" height="120px" [src]="video.path" type="video/mp4" class="mr-2"></video>
                    <div class="d-flex flex-column">
                      <p class="font-size-headline6 font-weight-regular mb-0">
                        {{ formatName(video.name) }}
                      </p>
                      <p>
                        {{ formatDate(video.date) }}
                      </p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="mt-3">
            <div class="text-center my-4">
              <img src="../../../../../assets/svg/empty-state_no-video.svg" alt="No videos available" />
              <p class="mb-0">No videos available</p>
            </div>
          </div>
        }
      </mat-tab>
      <mat-tab label="Documentation">
        <div class="mt-3">
          @if (files.length > 0) {
            <table matSort mat-table [dataSource]="files" class="w-100 documentation-container">
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef class="name-header">Title</th>
                <td mat-cell mat-header-cell *matCellDef="let item" class="name-column">
                  <img src="../../../../../assets/svg/pdf.svg" alt="pdf-file-icon" height="55px" class="image" />
                  {{ formatName(item.name) }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell mat-header-cell *matCellDef="let item">{{ formatDate(item.date) }}</td>
              </ng-container>
              <ng-container matColumnDef="path">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let item" class="open-column">
                  <a [href]="item.path" target="_blank"> Open </a>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: columns"></tr>
            </table>
          } @else {
            <div class="text-center my-4">
              <img src="../../../../../assets/svg/empty-state_no-pdfs.svg" alt="No PDF's available" />
              <p>No files available</p>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="mt-2 footer" mat-dialog-actions>
    <button mat-flat-button color="primary" class="ml-auto close-btn" (click)="close()">Close</button>
  </div>
</div>
